import 'model/init';
import { queryString } from 'libs/query-string';
import { ErrorDetails, VerifyOptions } from 'model/domain';
import { updateThemeFx, Theme } from 'model/helpers/theme';
import { subscribe, unsubscribe } from 'model/helpers/subscribers.model';
import { configureVerify, mountVerify, unmountVerify } from 'model/main.model';

export class Verify {
	static configure(applicationKey: string | { room: string }, options: Partial<VerifyOptions> = {}) {
		if (typeof applicationKey === 'object' && 'room' in applicationKey) {
			const [room, params = null] = applicationKey.room.split('?');

			configureVerify({
				room,
				params: queryString.decode(params),
			});
		} else {
			configureVerify({
				applicationKey,
				options,
			});
		}
	}

	static on(event: string, callback: Function) {
		const handleCallback = (payload: any) => {
			if (typeof callback === 'function') { callback(payload); }
		};
		subscribe({ event, callback: handleCallback });

		return () => {
			unsubscribe(handleCallback);
		};
	}

	static async updateTheme(theme: Theme) {
		await updateThemeFx({ theme });
	}

	static mount(container: HTMLElement, sessionToken: string) {
		mountVerify({ sessionToken, container });
	}

	static error(container: HTMLElement, error: ErrorDetails) {
		mountVerify({ error, container });
	}

	static unmount() {
		unmountVerify();
	}
}
